const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const LOWER = 'abcdefghijklmnopqrstuvwxyz'
const NUMS = '0123456789'
const SPECIAL = '!@#$%^&*'

const pick = (chars: string) => chars[Math.floor(Math.random() * chars.length)]

/**
 * Generates a 12-character temporary password that satisfies the Cognito
 * policy (upper, lower, number, special). Same rules as the admin Users page.
 */
export const generateTempPassword = (): string => {
    const required = [pick(UPPER), pick(LOWER), pick(NUMS), pick(SPECIAL)]
    const all = UPPER + LOWER + NUMS + SPECIAL
    while (required.length < 12) required.push(pick(all))
    return required.sort(() => Math.random() - 0.5).join('')
}

export const PASSWORD_RULES = [
    { label: 'At least 8 characters', test: (v: string) => v.length >= 8 },
    { label: 'An uppercase letter', test: (v: string) => /[A-Z]/.test(v) },
    { label: 'A lowercase letter', test: (v: string) => /[a-z]/.test(v) },
    { label: 'A number', test: (v: string) => /[0-9]/.test(v) },
    { label: 'A special character', test: (v: string) => /[^A-Za-z0-9]/.test(v) },
]

export const isPasswordValid = (v: string) => PASSWORD_RULES.every((r) => r.test(v))

export const validatePassword = (v: string): { valid: true } | { valid: false; message: string } => {
    const failed = PASSWORD_RULES.filter((r) => !r.test(v))
    if (!failed.length) return { valid: true }
    return { valid: false, message: `Password needs: ${failed.map((r) => r.label.toLowerCase()).join(', ')}.` }
}
